/**
 * @Description:    工具类
 * @Author:         TSY
 * @Email:          t@tsy6.com
 * @CreateDate:     2019/3/14 23:46
 */

/**
 * 检测图片是否存在
 * @param url
 */
export const imageIsExist = function(url) {
    return new Promise((resolve) => {
        var img = new Image();
        img.onload = function () {
            if (this.complete == true){
                /*alert("加载成功");*/
                resolve(true);
                img = null;
            }
        }
        img.onerror = function () {
            /*alert("加载发生错误");*/
            resolve(false);
            img = null;
        }
      /*alert("赋值url");*/
        img.src = url;
    })
}

/*export default {
  init: function (){
    const AK = "KEJBZ-UASLX-6AK43-77GEG-PKKO6-TYFEL";
    const TMap_URL = "https://map.qq.com/api/gljs?v=1.exp&libraries=tools,service&key="+ AK +"&callback=onMapCallback";
    return new Promise((resolve, reject) => {
      // 如果已加载直接返回
      if(typeof TMap !== "undefined") {
        resolve(TMap);
        return true;
      }
      // 地图异步加载回调处理
      window.onMapCallback = function () {
        resolve(TMap);
      };

      // 插入script脚本
      let scriptNode = document.createElement("script");
      scriptNode.setAttribute("type", "text/javascript");
      scriptNode.setAttribute("src", TMap_URL);
      document.body.appendChild(scriptNode);
    });
  }
}*/


export function qqMap(key) {
  return new Promise(function (resolve, reject) {
    window.init = function () {
      resolve();
    }

    var script = document.createElement("script");
    script.type = "text/javascript";
    script.src="http://map.qq.com/api/js?v=2.exp&key="+key;
    script.onerror = reject;
    document.head.appendChild(script);

    var script2 = document.createElement("script");
    script2.type = "text/javascript";
    script2.src="http://map.qq.com/api/gljs?v=2.exp&libraries=service&key="+key;
    script2.onerror = reject;
    document.head.appendChild(script2);
  })
}



// WEBPACK FOOTER //
// ./src/utils/utils.js